const calcWidth = (count, max) => {
    if (max === 0) {
        return "0%"
    }
    let per = Math.ceil(100 * (count / max))
    per = Math.max(per, 5)
    return per.toString() + '%'
}
const LeadFollowNoneIndicator = (props) => {
    const {leads, follows, other} = props
    const max = Math.max(leads, follows, other)

    const bgColor = '#CCCCCC'


    return <Container>
        <Bar percent={calcWidth(leads, max)} bgColor={bgColor}/>
        <Bar percent={calcWidth(follows, max)} bgColor={bgColor}/>
        <Bar percent={calcWidth(other, max)} bgColor={bgColor}/>
    </Container>
}



const Bar = (props) => {
    const {percent, bgColor} = props
    const style = {
        backgroundColor: bgColor,
        width: percent,
        height: "3px"

    }

    return <div style={style}>
    </div>
}

const innerBoxStyle = {
    width: "16px",
    height: "18px",
    marginTop: "2px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
}

const Container = (props) =>
        <div style={innerBoxStyle}>
            {props.children}
        </div>

export {LeadFollowNoneIndicator}